
export class DocumentModel{
  constructor(){
    this.id=0;
    this.name="";
    this.createdDate=null;
    this.updatedDate=null;
    this.access=[];
    this.subFolder=[];
  }

  access:DocumentRoleModel[];
  id: number;
  name: string;
  createdDate:Date;
  updatedDate:Date;
  subFolder: DocumentSubFolderModel[];
}

export class DocumentRoleModel{
constructor(){
  this.addAccess=false;
  this.readAccess=true;
  this.writeAccess=false;
  this.id=0;
}
      addAccess: boolean;
      readAccess: boolean;
      writeAccess: boolean;
      id: number;
      role: RoleModel;
      serviceVertical: ServiceVerticalModel;
}

export class RoleModel{
  constructor(){
    this.id= 0;
    this.name = ""
  }
    id: number;
    name : String;
}

export class ServiceVerticalModel{
  constructor(){
    this.id= 0;
    this.name = ""
  }
    id: number;
    name : String;
}

export class DocumentSubFolderModel{
  id: number;
  name: string;
  createdDate:Date;
  updatedDate:Date;
  access:DocumentRoleModel[];
  subFolder: DocumentSubFolderModel[];
}
